/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./HeaderNotificationsButton.vue?vue&type=template&id=4f32d28c"
import script from "./HeaderNotificationsButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderNotificationsButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HeaderNotificationsButton.vue?vue&type=style&index=0&id=4f32d28c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports